import React from "react";
import logoTools from "../assets/res/logo.png";
import SearchBar from "./Search";

function Header({ querySearched }) {
  return (
    <div className="relative">
      {/* playful red hero */}
      <div className="relative overflow-hidden rounded-bl-[32px] rounded-br-[32px] bg-gradient-to-br from-primary via-primary to-primaryDark px-6 pt-6 pb-12 text-center shadow-sm">
        {/* decorative bubbles */}
        <div className="pointer-events-none absolute -left-8 -top-8 h-28 w-28 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute -right-6 top-14 h-24 w-24 rounded-full bg-white/10" />
        <div className="pointer-events-none absolute right-7 top-4 h-4 w-4 rounded-full bg-white/20" />
        <div className="pointer-events-none absolute left-10 top-3 h-3 w-3 rounded-full bg-white/30" />
        <div className="pointer-events-none absolute bottom-12 right-16 h-2.5 w-2.5 rounded-full bg-white/30" />

        {/* logo */}
        <img
          src={logoTools}
          alt="Duck Arena"
          className="float relative mx-auto h-[84px] w-[84px] drop-shadow-lg"
        />

        {/* wordmark */}
        <h1 className="bold relative mt-2 text-4xl uppercase tracking-[0.06em] text-white drop-shadow-sm">
          Duck <span className="text-primaryWhite">Arena</span>
        </h1>

        {/* tagline */}
        <div className="relative mt-2 flex justify-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-[11px] uppercase tracking-[0.22em] text-white">
            mods • games • apps
          </span>
        </div>
      </div>

      {/* floating search over the curve */}
      <div className="relative z-10 -mt-10">
        <SearchBar querySearched={querySearched} />
      </div>
    </div>
  );
}

export default Header;
